<div class="menu-arbol-container">
    <app-menu-arbol [ctx]="ctx" (renderMenuArbolEmitter)="emitRenderMenuArbol($event)"></app-menu-arbol>
</div>